(function () {
  'use strict';
  var strings = window.themeStrings || {};

  function formatMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'it', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function initProduct(section) {
    var picker = section.querySelector('[data-variant-picker]');
    var mainMedia = section.querySelector('[data-main-media]');
    var thumbs = section.querySelectorAll('[data-thumb]');

    function showMedia(src, mediaId) {
      if (!mainMedia || !src) return;
      var img = mainMedia.querySelector('img');
      if (img) {
        img.removeAttribute('srcset');
        img.src = src;
      }
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', String(t.dataset.mediaId) === String(mediaId));
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showMedia(thumb.dataset.src, thumb.dataset.mediaId);
      });
    });

    // Quantità
    section.querySelectorAll('.quantity').forEach(function (q) {
      var input = q.querySelector('input');
      q.querySelectorAll('[data-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || 1;
          input.value = btn.dataset.qty === 'plus' ? val + 1 : Math.max(1, val - 1);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    // Varianti
    if (picker) {
      var jsonEl = picker.querySelector('[data-variants-json]');
      var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
      var idInput = section.querySelector('[data-variant-id]');
      var addBtn = section.querySelector('[data-add-button]');
      var priceEl = section.querySelector('[data-price]');

      picker.addEventListener('change', function () {
        var selected = [];
        picker.querySelectorAll('fieldset').forEach(function (fs, i) {
          var checked = fs.querySelector('input:checked');
          selected[i] = checked ? checked.value : null;
          var label = picker.querySelector('[data-option-label="' + i + '"]');
          if (label && checked) label.textContent = checked.value;
        });

        var variant = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });

        if (!variant) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = strings.unavailable; }
          return;
        }

        if (idInput) idInput.value = variant.id;
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? strings.addToCart : strings.soldOut;
        }

        if (priceEl) {
          var compare = priceEl.querySelector('.price__compare');
          var current = priceEl.querySelector('.price__current');
          var badge = priceEl.querySelector('.badge--sale');
          var priceWrap = priceEl.querySelector('.price');
          if (current) current.textContent = formatMoney(variant.price);
          var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          if (compare) {
            compare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
            compare.hidden = !onSale;
          } else if (onSale && priceWrap && current) {
            var s = document.createElement('s');
            s.className = 'price__compare';
            s.textContent = formatMoney(variant.compare_at_price);
            priceWrap.insertBefore(s, current);
          }
          if (badge) badge.hidden = !onSale;
        }

        if (variant.featured_media) {
          var thumb = section.querySelector('[data-thumb][data-media-id="' + variant.featured_media.id + '"]');
          var src = thumb ? thumb.dataset.src : variant.featured_media.preview_image && variant.featured_media.preview_image.src;
          showMedia(src, variant.featured_media.id);
        }

        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      });
    }

    // Condividi
    var share = section.querySelector('[data-share]');
    if (share) {
      share.addEventListener('click', function () {
        var url = share.dataset.url;
        if (navigator.share) {
          navigator.share({ title: share.dataset.title, url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            var label = share.querySelector('[data-share-label]');
            var original = label.textContent;
            label.textContent = strings.copied;
            setTimeout(function () { label.textContent = original; }, 2000);
          });
        }
      });
    }
  }

  // Prodotti correlati (caricati via Section Rendering API)
  function initRecommendations(el) {
    if (!el.dataset.url || el.children.length) return;
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  // ---------- Carrello laterale ----------
  var settings = window.themeSettings || {};
  var routes = window.routes || {};
  var lastFocus = null;

  function getDrawer() { return document.querySelector('[data-cart-drawer]'); }

  function drawerEnabled() {
    return settings.cartType === 'drawer' && !!getDrawer() && !document.body.classList.contains('template-cart');
  }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-drawer-open');
    var panel = drawer.querySelector('.cart-drawer__panel');
    if (panel) setTimeout(function () { panel.focus(); }, 50);
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cart-drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  // Sostituisce il contenuto del drawer con l'HTML fresco della sezione
  function renderDrawer(html) {
    var drawer = getDrawer();
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var freshPanel = doc.querySelector('.cart-drawer__panel');
    var panel = drawer.querySelector('.cart-drawer__panel');
    if (freshPanel && panel) panel.innerHTML = freshPanel.innerHTML;
  }

  function refreshDrawer() {
    var base = routes.root_url || '/';
    if (base.slice(-1) !== '/') base += '/';
    return Promise.all([
      fetch(base + '?section_id=cart-drawer').then(function (r) { return r.text(); }),
      fetch((routes.cart_url || '/cart') + '.js').then(function (r) { return r.json(); })
    ]).then(function (res) {
      renderDrawer(res[0]);
      updateCount(res[1].item_count);
    });
  }

  function showFormError(form, message) {
    var box = form.querySelector('[data-form-error]');
    if (!box) {
      box = document.createElement('p');
      box.className = 'product-form__error';
      box.setAttribute('data-form-error', '');
      box.setAttribute('role', 'alert');
      form.appendChild(box);
    }
    box.textContent = message;
    box.hidden = !message;
  }

  function initCartDrawer() {
    if (settings.cartType !== 'drawer') return;

    // Aggiungi al carrello -> apri drawer
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]') || !drawerEnabled()) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var wasDisabled = btn ? btn.disabled : false;
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      showFormError(form, '');

      var data = new FormData(form);
      // Quantità fuori dal form (attributo form=)
      if (form.id && !data.get('quantity')) {
        var qty = document.querySelector('input[name="quantity"][form="' + form.id + '"]');
        if (qty) data.append('quantity', qty.value);
      }
      data.append('sections', 'cart-drawer');
      data.append('sections_url', window.location.pathname);

      fetch((routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: data
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) {
            showFormError(form, res.json.description || res.json.message || strings.cartError);
            return;
          }
          if (res.json.sections && res.json.sections['cart-drawer']) renderDrawer(res.json.sections['cart-drawer']);
          return fetch((routes.cart_url || '/cart') + '.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) { updateCount(cart.item_count); openDrawer(); });
        })
        .catch(function () { form.submit(); })
        .finally(function () {
          if (btn) { btn.classList.remove('is-loading'); btn.disabled = wasDisabled; }
        });
    });

    document.addEventListener('click', function (e) {
      // Icona carrello
      var icon = e.target.closest('[data-cart-icon]');
      if (icon && settings.cartDrawerOnIcon && drawerEnabled()) {
        e.preventDefault();
        refreshDrawer().then(openDrawer);
        return;
      }
      // Chiudi
      if (e.target.closest('[data-cart-close]')) {
        e.preventDefault();
        closeDrawer();
        return;
      }
      // Quantità / rimuovi
      var qtyBtn = e.target.closest('[data-cart-qty]');
      if (qtyBtn && getDrawer() && getDrawer().contains(qtyBtn)) {
        e.preventDefault();
        var body = getDrawer().querySelector('.cart-drawer__panel');
        if (body) body.classList.add('is-loading');
        fetch((routes.cart_change_url || '/cart/change') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: parseInt(qtyBtn.dataset.line, 10),
            quantity: Math.max(0, parseInt(qtyBtn.dataset.cartQty, 10) || 0),
            sections: ['cart-drawer'],
            sections_url: window.location.pathname
          })
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (cart.sections && cart.sections['cart-drawer']) renderDrawer(cart.sections['cart-drawer']);
            if (typeof cart.item_count === 'number') updateCount(cart.item_count);
          })
          .catch(function () {})
          .finally(function () {
            var p = getDrawer() && getDrawer().querySelector('.cart-drawer__panel');
            if (p) p.classList.remove('is-loading');
          });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && getDrawer() && getDrawer().classList.contains('is-open')) closeDrawer();
    });

    // Ritorno con il tasto "indietro" dal checkout: aggiorna il drawer
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && getDrawer()) refreshDrawer();
    });
  }

  // ---------- Righe espandibili: una aperta alla volta ----------
  function initAccordions(root) {
    root.querySelectorAll('[data-accordion-group]').forEach(function (group) {
      group.querySelectorAll('details').forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          group.querySelectorAll('details[open]').forEach(function (other) {
            if (other !== d) other.open = false;
          });
        });
      });
    });
  }

  function init(root) {
    root.querySelectorAll('[data-product-section]').forEach(initProduct);
    root.querySelectorAll('[data-recommendations]').forEach(initRecommendations);
    initAccordions(root);
  }

  document.addEventListener('DOMContentLoaded', initCartDrawer);

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
